import { defineLocalizedRoute } from '@sigma/common/routes/defineLocalizedRoute.js';
import { defineRoute } from '@sigma/common/routes/defineRoute.js';
export const HomeRoute = defineRoute({
    name: 'patient:home',
    path: '/',
});
export const LandingRoute = defineLocalizedRoute({
    name: 'patient:landing',
    path: {
        en: '',
        pl: '',
    },
});
export const ChatsRoute = defineLocalizedRoute({
    name: 'patient:chats',
    path: {
        en: '/chats',
        pl: '/czaty',
    },
});
export const ChatRoute = defineLocalizedRoute({
    name: 'patient:chat',
    path: {
        en: '/chat/:chatId',
        pl: '/chat/:chatId',
    },
});
export const ChatStartRoute = defineLocalizedRoute({
    name: 'patient:chat:start',
    path: {
        en: '/chat/start/:agentUid',
        pl: '/chat/start/:agentUid',
    },
});
export const LoginRoute = defineLocalizedRoute({
    name: 'patient:login',
    path: {
        en: '/login',
        pl: '/zaloguj',
    },
});
export const LogoutRoute = defineLocalizedRoute({
    name: 'patient:logout',
    path: {
        en: '/logout',
        pl: '/wyloguj',
    },
});
export const ProfileRoute = defineLocalizedRoute({
    name: 'patient:profile',
    path: {
        en: '/profile',
        pl: '/twoj-profil',
    },
});
export const PrivacyPolicyRoute = defineLocalizedRoute({
    name: 'patient:privacyPolicy',
    path: {
        en: '/privacy-policy',
        pl: '/polityka-prywatnosci',
    },
});
export const TermsOfServiceRoute = defineLocalizedRoute({
    name: 'patient:termsOfService',
    path: {
        en: '/terms-of-service',
        pl: '/regulamin',
    },
});
export const AccessibilityStatementRoute = defineLocalizedRoute({
    name: 'patient:accessibilityStatement',
    path: {
        en: '/accessibility-statement',
        pl: '/o-dostepnosci',
    },
});
export const LegalNoticeRoute = defineLocalizedRoute({
    name: 'patient:legalNotice',
    path: {
        en: '/legal-notice',
        pl: '/informacje-prawne',
    },
});
export const PatientDetailsRoute = defineRoute({
    name: 'patient:patients:details',
    path: '/patients/:patientId',
});
export const PatientDetailsDashboardRoute = defineRoute({
    name: 'patient:patients:details:dashboard',
    path: '/patients/:patientId',
});
export const PatientDetailsChatRoute = defineRoute({
    name: 'patient:patients:details:chat',
    path: '/patients/:patientId/chats/:chatId',
});
//# sourceMappingURL=routes.js.map